import { Component, input } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatStepper } from '@angular/material/stepper';

// Navegación vertical de un formulario por pasos (página): cada paso con su
// número o estado (completo / con error) y un detalle. Se usa junto a un
// mat-stepper con la clase `form-pasos-stepper` (que oculta su barra
// horizontal), dentro de un contenedor `form-pasos-layout`.
@Component({
  selector: 'app-pasos-nav',
  templateUrl: './pasos-nav.component.html',
  imports: [NgTemplateOutlet, MatIconModule],
})
export class PasosNavComponent {
  readonly stepper = input.required<MatStepper>();
  readonly etiqueta = input('Pasos del formulario');
}
